// Shared media-URL resolution.
//
// The API returns either absolute URLs (Cloudinary in production) or
// backend-relative /media/ paths (local-disk storage in dev). resolveUrl()
// normalizes both to something an <img>/<video> can load.
//
// Was previously copy-pasted into five page components — import from here.

export const MEDIA_BASE = process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000';

export const resolveUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${MEDIA_BASE}${url}`;
};
